<template>
  <div class="flex">
    <div class="block"></div>
    <div class="block-text">初始数据</div>
    <div class="block block1"></div>
    <div class="block-text">增补数据</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref ,onMounted,PropType,watch} from "vue";


export default defineComponent({
  isGlobal: true,
  name: "BudgetColorBlock",

  setup() {

  },
});
</script>
<style lang="less">
  .block{
    width: 48px;
    height: 22px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #2F7BFF
  }
  .block1{
    background: #EDF3FF;
    border: 1px solid #2F7BFF;
    margin-left: 24px;
  }
  .block-text{
    margin-left: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }

</style>
